module.exports = "/lucky-balls/img/drum/drum_loop_030.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_030.png
// module id = 1045
// module chunks = 0